import { config } from "../config";

export const resizeImage = (imageUrl: string = '', pageName: string = '') => {
    const { width, heigth } = config('renderingImgData').screens[pageName];
    if (imageUrl?.includes('scene.products.cimpress.io')) {
        imageUrl = `${config('renderingImgData').Url}width=${width}&height=${heigth}&scene=${encodeURIComponent(imageUrl.split('?')[0])}`;
    } else if (imageUrl?.includes('scenes.documents.cimpress.io')) {
        let stripImageUrl = imageUrl.split('?')[0];
        const stripIndex = stripImageUrl.indexOf('/assets/'); //remove assests
        stripImageUrl = stripImageUrl.substring(0, stripIndex);
        imageUrl = `${config('renderingImgData').Url}width=${width}&height=${heigth}&scene=${encodeURIComponent(stripImageUrl)}/index`;    
    } else if (imageUrl?.includes('rackcdn')) { //rackcdn is source of images on ctools ref:https://docs.commercetools.com/http-api-projects-products.html#images             
        const rackSizeStr = width > 700 ? '-zoom'
            : width > 400 ? '-large'
                : width > 150 ? '-medium'
                    : width > 50 ? '-small'
                        : '-thumb';
        imageUrl = imageUrl.substring(0, imageUrl.lastIndexOf('.')) + rackSizeStr + imageUrl.substring(imageUrl.lastIndexOf('.'));
    }
    return imageUrl;
};

export const merchantisePantoneColor = (name = '') => {
    if(name === ''){
        return{
            displayName: 'White',
            rgb: 'rgb(255,255,255)'
        }
    }
    const pantoneColors:any = config('pantoneColors') || ''
    const response= pantoneColors && pantoneColors.filter((pantoneColor) => pantoneColor['formattedPantone'] === name || pantoneColor['name'] === name)
    return response.length > 0 ? response[0] : {
        displayName: name,
        rgb: name
    };
};

export const PATH_ID = {
    ARROW: 'M35 70L65 25L65 115L35 70Z',
    TOOL_TIP: 'M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 13C7.4 13 7 12.6 7 12C7 11.4 7.4 11 8 11C8.6 11 9 11.4 9 12C9 12.6 8.6 13 8 13ZM9.5 8.4C9 8.7 9 8.8 9 9V10H7V9C7 7.7 7.8 7.1 8.4 6.7C8.9 6.4 9 6.3 9 6C9 5.4 8.6 5 8 5C7.6 5 7.3 5.2 7.1 5.5L6.6 6.4L4.9 5.4L5.4 4.5C5.9 3.6 6.9 3 8 3C9.7 3 11 4.3 11 6C11 7.4 10.1 8 9.5 8.4Z',
    SUBMIT_LOCK: 'M18 9H16V7.5C16 5.57 14.43 4 12.5 4C10.57 4 9 5.57 9 7.5V9H7C6.724 9 6.5 9.224 6.5 9.5V19.5C6.5 19.776 6.724 20 7 20H18C18.276 20 18.5 19.776 18.5 19.5V9.5C18.5 9.224 18.276 9 18 9ZM13 15.429V17H12V15.429C11.14 15.2055 10.5 14.429 10.5 13.5C10.5 12.397 11.397 11.5 12.5 11.5C13.603 11.5 14.5 12.397 14.5 13.5C14.5 14.429 13.86 15.2055 13 15.429ZM15 9H10V7.5C10 6.1215 11.1215 5 12.5 5C13.8785 5 15 6.1215 15 7.5V9Z',
    CROSS: 'M10.4998 0.439453L5.99984 4.93945L1.49984 0.439453L0.438965 1.50033L4.93897 6.00033L0.438965 10.5003L1.49984 11.5612L5.99984 7.0612L10.4998 11.5612L11.5607 10.5003L7.06072 6.00033L11.5607 1.50033L10.4998 0.439453Z'
  }